import { Paper as MaterialPaper, withStyles } from '@material-ui/core';

export const Paper = withStyles({
  root: {
    borderRadius: 16,
  },
})(MaterialPaper);
